import '../globalStyles.css';
import './FirstNote.css';

export default function FirstNote ( ){
  return(
    <>
      <img className='aliens__img' src='/assets/animaciones/aliens.svg' alt="Aliens"/>
      <p className='aliens__text'>Crea tu primera nota...</p>
    </>
  )
}